import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateVesselParams } from "../operation";
import { VESSEL_KEYS } from "./vessel.keys";
import { vesselServices } from "./vessel.services";
import {
  CreateShuttleParams,
  UpdateShuttleParams,
  UpdateVesselParams,
} from "./vessel.types";

export const useCreateVessel = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: VESSEL_KEYS.CREATE_VESSEL(),
    mutationFn: (params: CreateVesselParams) =>
      vesselServices.createVessel(params),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VESSEL_KEYS.GET_VESSELS(),
      });
    },
  });
};

export const useUpdateVessel = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: VESSEL_KEYS.UPDATE_VESSEL(),
    mutationFn: (params: UpdateVesselParams & { id: string }) =>
      vesselServices.updateVessel(params),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VESSEL_KEYS.GET_VESSELS(),
      });
    },
  });
};

export const useDeleteVessel = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: VESSEL_KEYS.DELETE_VESSEL(),
    mutationFn: (id: string) => vesselServices.deleteVessel(id),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VESSEL_KEYS.GET_VESSELS(),
      });
    },
  });
};

export const useCreateShuttle = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: VESSEL_KEYS.CREATE_SHUTTLE(),
    mutationFn: (params: CreateShuttleParams) =>
      vesselServices.createShuttle(params),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VESSEL_KEYS.GET_SHUTTLES(),
      });
    },
  });
};

export const useUpdateShuttle = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: VESSEL_KEYS.UPDATE_SHUTTLE(),
    mutationFn: (params: UpdateShuttleParams & { id: string }) =>
      vesselServices.updateShuttle(params),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VESSEL_KEYS.GET_SHUTTLES(),
      });
    },
  });
};

export const useDeleteShuttle = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: VESSEL_KEYS.DELETE_SHUTTLE(),
    mutationFn: (id: string) => vesselServices.deleteShuttle(id),
    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: VESSEL_KEYS.GET_SHUTTLES(),
      });
    },
  });
};
